import React, { useCallback, useEffect, useMemo, useState } from "react";
import { ErrorCode, FileType, ResetErrorCode } from "../../types";
import noPermissionImg from "@/assets/img/joyspce/no-permission.png";
import DelImg from "@/assets/img/supervise-empty.png";
import "./index.less";
import { joyspacePermissionType } from "../../config/permissions.config";
import { Select, Input, Button, message } from "antd";
import { create, getOwner } from "../../api/pageApply";
import { useHistory, useLocation } from "react-router-dom";
import { connect } from "dvajs";
import { UserState } from "@/models/user";
import ChatState from "@/types/chat/State";
import useCustomUserCardModal from "@/components/Modals/useCustomUserCardModal";
import { UserCardType } from "@/types/UserCard";
import events from "../../context/events";
import { analysisLog } from "@/utils/logAnalytics";
import { getFileInfo } from "../../reloadUtils";
import qs from "query-string";
const { Option } = Select;
interface IProps {
  code: ErrorCode;
  currentEmployee: any;
  userData: any;
  openCreateContactModal: Function;
  addFolderInfo: Function;
  setCurrentRouterInfoById: Function;
}
let options = [
  { value: joyspacePermissionType.ReadOnly, label: "仅阅读", desc: "可查看文档和文件夹" },
  { value: joyspacePermissionType.ReadWrite, label: "可编辑", desc: "可查看/编辑文档和文件夹" }
];
const ErrorMsg = (props: IProps) => {
  const {
    addFolderInfo,
    currentEmployee,
    userData,
    openCreateContactModal,
    setCurrentRouterInfoById
  } = props;
  const [imgSrc, setImgSrc] = useState("");
  const [text, setText] = useState("");
  const [remark, setRemark] = useState("");
  const [folderInfo, setFolderInfo] = useState<any>(null);
  const [owner, setOwner] = useState<any>([]);
  const [isRoot, setRoot] = useState(true);
  const [name, setFolderName] = useState([]);
  const [folderId, setFolderId] = useState<string | null>(null);
  const [tagId, setTagId] = useState<string | null>(null);
  const [code, setCode] = useState<string | null>(null);
  const [currentPermission, setCurrentPermission] = useState(joyspacePermissionType.ReadOnly);
  const history = useHistory();
  const location = useLocation();
  const { openCustomUserCardModal } = useCustomUserCardModal({
    openCreateContactModal,
    userData,
    currentEmployee
  });
  useEffect(() => {
    console.log("location.search222", location.search);
    const query = qs.parse(location.search);
    if (query.code) {
      // @ts-ignore
      setCode(query.code);
    } else {
      setCode(null);
    }
    if (query.tagId) {
      // @ts-ignore
      setTagId(query.tagId);
    } else {
      setTagId(null);
    }
    if (query.folderId) {
      // @ts-ignore
      setFolderId(query.folderId);
    } else {
      setFolderId(null);
    }
  }, [location]);
  useEffect(() => {
    setCurrentRouterInfoById(null);
    events.emit("deleteFolderById", folderId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folderId]);
  useEffect(() => {
    if ((code !== ErrorCode.noPermission && code !== ResetErrorCode.noPermission) || !folderId) {
      return;
    }
    getOwner(folderId).then((res: any) => {
      if (!res) {
        return;
      }
      const { ownerVos, folderVo } = res;
      setFolderInfo(folderVo);
      setOwner(ownerVos || []);
      const names = folderVo.full_name.split("$@$");
      if (names.length > 0) {
        setFolderName(names[0]);
      } else {
        setFolderName(folderVo.name);
      }
      folderVo.full_path && setRoot(!folderVo.full_path.includes("$@$"));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, folderId]);
  useEffect(() => {
    if (tagId) {
      if (code === ErrorCode.Delete || code === ResetErrorCode.Delete) {
        setImgSrc(DelImg);
        setText("该标签不存在");
      } else if (code === ErrorCode.noPermission || code === ResetErrorCode.noPermission) {
        setImgSrc(noPermissionImg);
        // 您暂无权限访问当前子文件夹
        const text = isRoot ? "您暂无权限访问当前标签" : "您暂无权限访问当前标签";
        setText(text);
      }
    } else {
      if (code === ErrorCode.Delete || code === ResetErrorCode.Delete) {
        setImgSrc(DelImg);
        setText("该文件夹不存在");
      } else if (code === ErrorCode.noPermission || code === ResetErrorCode.noPermission) {
        setImgSrc(noPermissionImg);
        // 您暂无权限访问当前子文件夹
        const text = isRoot ? "您暂无权限访问当前文件夹" : "您暂无权限访问当前子文件夹";
        setText(text);
      } else if (code === "openFolderError") {
        setImgSrc(DelImg);
        // 文件夹打开失败
        const text = "";
        setText("文件夹打开失败");
      }
    }
  }, [code, isRoot, tagId]);
  const checkFolder = useCallback(() => {
    if (!folderId) return;
    getFileInfo(FileType.Folder, folderId)
      .then((res: any) => {
        if (!res) {
          return;
        }
        addFolderInfo([res]);
        history.push("/joyspace/teamspace?categoryId=" + folderId);
      })
      .catch((err) => {
        message.success("刷新成功，请先申请权限，若已申请请耐心等待所有者审批");
      });
  }, [addFolderInfo, history, folderId]);
  const onReload = useCallback(() => {
    checkFolder();
  }, [checkFolder]);
  const submit = useCallback(() => {
    if (!folderId) {
      console.error("folderId on null");
      return;
    }
    analysisLog("xtbg_joyspace_web_noAuth_apply", "folderId", folderId);
    create(folderId, FileType.Folder, currentPermission, remark).then((res) => {
      // console.log(res, "res====>");
      if (res.code === "200") {
        message.success("申请已发送");
      } else {
        message.error(res.status || "操作失败");
      }
    });
  }, [currentPermission, folderId, remark]);
  const ownerDOM = useMemo(() => {
    if (owner.length > 0) {
      return (
        <>
          （
          <span
            className="joyspce-reverso-owner"
            onClick={() => {
              if (!owner.length) {
                return;
              }
              console.log(owner);
              const { userId, appId, teamId } = owner[0];
              openCustomUserCardModal({
                data: {
                  type: UserCardType.CustomUser,
                  userId,
                  appId,
                  teamId
                },
                currentUserData: currentEmployee
              });
            }}
          >
            {owner[0]?.userName}
          </span>
          {owner.length > 1 ? "等" : ""}）
        </>
      );
    }
    return null;
  }, [currentEmployee, openCustomUserCardModal, owner]);
  const reversoContext = useCallback(() => {
    return (
      <div className="joyspce-reverso-box">
        <div className="joyspce-reverso-main">
          {folderInfo && (
            <div>
              {isRoot ? "向当前文件夹" : "向所属父级文件夹"}（
              <span className="joyspce-reverso-name">{name}</span>
              ）的所有者{ownerDOM}申请权限
            </div>
          )}
          <Select
            size="large"
            defaultValue={currentPermission}
            className="joyspce-reverso-select"
            onChange={(value) => {
              setCurrentPermission(value);
            }}
          >
            {options.map((item: any, index) => (
              <Option
                className={
                  currentPermission === item.value
                    ? "joyspce-reverso-option joyspce-reverso-selected"
                    : "joyspce-reverso-option"
                }
                value={item.value}
                key={index}
              >
                <h4>{item.label}</h4>
                <p>{item.desc}</p>
              </Option>
            ))}
          </Select>
          <p>申请原因（选填）</p>
          <div className="form-item-input">
            <Input.TextArea
              rows={4}
              placeholder="请输入"
              maxLength={20}
              onChange={(event) => {
                setRemark(event.target.value);
              }}
            />
            <p className="form-item-length" style={{ marginBottom: 20 }}>
              {remark.length}/20
            </p>
          </div>
        </div>
        <div className="footer">
          <Button type="primary" onClick={submit}>
            申 请
          </Button>
          <p className="reload" onClick={onReload}>
            刷新
          </p>
        </div>
      </div>
    );
  }, [folderInfo, isRoot, name, ownerDOM, currentPermission, remark.length, submit, onReload]);
  return imgSrc ? (
    <div className="joyspace-list-table joyspace-empty">
      <img src={imgSrc} />
      <p>{text}</p>
      {(code === ErrorCode.noPermission || code === ResetErrorCode.noPermission) &&
        reversoContext()}
    </div>
  ) : null;
};

function mapStateToProps({ user, chat }: { user: UserState; chat: ChatState }) {
  return {
    currentEmployee: chat.currentEmployee,
    userData: user.userData.user
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    openCreateContactModal(data: any) {
      dispatch({ type: "ebook/openCreateContactModal", payload: data });
    },
    addFolderInfo(list: any) {
      return dispatch({ type: "joyspace/addFolderInfo", payload: { list } });
    },
    setCurrentRouterInfoById(data: any) {
      dispatch({ type: "joyspace/setCurrentRouterInfoById", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorMsg);
